import { DropdownMenu } from '@/components/ui/dropdown-menu';

import type { ReactNode } from 'react';

type FieldOptionMenuProps = {
  label: string;
  options: readonly string[];
  className?: string;
  onSelect: (value: string) => void;
  children: ReactNode;
};

export const FieldOptionMenu = ({
  label,
  options,
  className,
  onSelect,
  children,
}: FieldOptionMenuProps) => (
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild>
      <button type="button" aria-label={label} className={className}>
        {children}
      </button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content align="start" fit>
      {options.map((option) => (
        <DropdownMenu.Item key={option} onSelect={() => onSelect(option)}>
          {option}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu.Content>
  </DropdownMenu.Root>
);
